/*
 * Vertical scrolling for the desktop thumbnail rail.
 *
 * Dawn's own slider buttons scroll horizontally, which does nothing once the
 * rail is stacked, so this adds its own up/down pair. They only appear when the
 * thumbnails are taller than the rail, which is capped to the main image.
 */
(function () {
  const CARET =
    '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeButton(direction, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'thumbnail-rail__button thumbnail-rail__button--' + direction;
    button.setAttribute('aria-label', label);
    button.innerHTML = CARET;
    return button;
  }

  function setup(rail) {
    if (rail.dataset.railReady === 'true') return;
    const list = rail.querySelector('.thumbnail-list');
    if (!list) return;
    rail.dataset.railReady = 'true';

    const up = makeButton('up', 'Previous thumbnails');
    const down = makeButton('down', 'Next thumbnails');
    rail.insertBefore(up, list);
    rail.appendChild(down);

    function step() {
      const item = list.querySelector('.thumbnail-list__item');
      if (!item) return 120;
      const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
      return item.getBoundingClientRect().height + gap;
    }

    function sync() {
      // 1px of tolerance: sub-pixel layout otherwise reports a permanent overflow
      const overflowing = list.scrollHeight > list.clientHeight + 1;
      rail.classList.toggle('thumbnail-rail--overflowing', overflowing);
      if (!overflowing) return;
      up.disabled = list.scrollTop <= 1;
      down.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    }

    up.addEventListener('click', function () {
      list.scrollBy({ top: -step(), behavior: 'smooth' });
    });
    down.addEventListener('click', function () {
      list.scrollBy({ top: step(), behavior: 'smooth' });
    });
    list.addEventListener('scroll', sync, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(list);
    }
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();
  }

  function init() {
    document
      .querySelectorAll('media-gallery[data-desktop-layout="thumbnail"] .thumbnail-slider')
      .forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);
  // the theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', init);
  init();
})();
